import { render, staticRenderFns } from "./Rastreabilidade.vue?vue&type=template&id=20ffcb84"
import script from "./Rastreabilidade.vue?vue&type=script&lang=js"
export * from "./Rastreabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports